import React from 'react';
import { Card } from 'react-bootstrap';
import { ModashHealthStatusEnum } from '../../../enum/ModashHealthStatusEnum';
import { ModashStatusBadge } from './ModashStatusBadge';

export function ModashStatusLegend() {
    return (
        <Card className="mb-5 p-4">
            <h5 className="mb-3">Status legend</h5>
            <p className="mb-2">
                <ModashStatusBadge status={ModashHealthStatusEnum.HEALTHY} /> Less than 20% of the last 50 requests
                (past 5 minutes) failed, or there were no requests.
            </p>
            <p className="mb-2">
                <ModashStatusBadge status={ModashHealthStatusEnum.DEGRADED} /> 20% to 40% of the last 50 requests (past
                5 minutes) failed.
            </p>
            <p className="mb-2">
                <ModashStatusBadge status={ModashHealthStatusEnum.UNHEALTHY} /> More than 40% of the last 50 requests
                (past 5 minutes) failed.
            </p>
            <small className="text-muted">
                A request counts as failed if it returns HTTP 500 or higher or takes longer than 20 seconds. The overall
                status is the worst status among all endpoint groups. RAW API endpoints are not included.
            </small>
        </Card>
    );
}
